import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ColorModeProvider from './context/ColorMode';
import reportWebVitals from './reportWebVitals';

// ColorModeProvider owns the ThemeProvider now: the theme depends on the
// resolved colour mode, so it has to be built inside a component that can
// re-render when the OS (or the user) changes it.
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ColorModeProvider>
      <App />
    </ColorModeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
